import app from "@/common/plugins/vueInstance";
import Maska from "maska";

app.use(Maska);
